var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNotification = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.915,
    height: 17.897,
    viewBox: "0 0 14.915 17.897",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(-1296 -221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(1296 223.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M57.519,87.152l-1.281-2.134a6.344,6.344,0,0,1-.9-3.262V79.887a5.22,5.22,0,0,0-10.44,0v1.869a6.344,6.344,0,0,1-.9,3.262l-1.281,2.134a.372.372,0,0,0,.32.565H57.2a.373.373,0,0,0,.32-.565Zm-13.83-.181.942-1.57a7.083,7.083,0,0,0,1.01-3.645V79.887a4.474,4.474,0,1,1,8.948,0v1.869A7.089,7.089,0,0,0,55.6,85.4l.943,1.57H43.689Z",
    transform: "translate(-42.657 -74.667)",
    fill: "var(--es--svg--fill--contrast)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(1301.966 221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M214.824,0a1.493,1.493,0,0,0-1.491,1.491V2.983a.373.373,0,0,0,.746,0V1.491a.746.746,0,0,1,1.491,0V2.983a.373.373,0,0,0,.746,0V1.491A1.493,1.493,0,0,0,214.824,0Z",
    transform: "translate(-213.333)",
    fill: "var(--es--svg--fill--contrast)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(1301.593 235.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M206.144,426.863a.373.373,0,0,0-.644.377,1.119,1.119,0,1,1-1.937,0,.373.373,0,0,0-.644-.377,1.865,1.865,0,1,0,3.226,0Z",
    transform: "translate(-202.666 -426.68)",
    fill: "var(--es--svg--fill--contrast)"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotification, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/notification.1b7ec81b.svg";
export { ForwardRef as ReactComponent };